/** Código hecho por Lucía Cosío de Smartime
 *          https://smartime.es/
 * 
 * El código está separado en varios roles:
 *  - Administrados: empresa de cloudtainer proveedora de candados.
 *  - Supervisor: empresa que compra / alquila los candados.
 *  - Operario: el usuario que transporta mercancía con los candados.
 * 
 * Esta app lleva la trazabilidad de los candados de cloudtainer.
 */
import { Routes, Route, useLocation } from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute";
import RoleRedirect from "./components/RoleRedirect";
import Sidebar from "./layouts/Siderbar";
import Login from "./layouts/Login";

import MaintenancePage from "./MaintenancePage";

import { adminRoutes } from "./router/admin.router";
import { supervisorRoutes } from "./router/supervisor.router";
import { commonRoutes } from "./router/common.router";

const allRoutes = [
  ...adminRoutes,
  ...supervisorRoutes,
  ...commonRoutes,
];

const MAINTENANCE_MODE = false;

export default function App() {
  const location = useLocation();

  if (MAINTENANCE_MODE) {
    return <MaintenancePage />;
  }

  const hideSidebar = location.pathname === "/login";
  const showSidebar = !hideSidebar;

  return (
    <div className="flex h-[100svh] overflow-hidden">
      {showSidebar && <Sidebar />}

      {/* margen solo en ≥lg */}
      <main className={`flex-1 overflow-y-auto min-h-0 ${showSidebar ? "lg:ml-64" : ""} pt-12 lg:pt-0`}>
        <Routes>
          <Route path="/login" element={<Login />} />

          {/* Redirección por rol en "/" */}
          <Route path="/" element={<ProtectedRoute><RoleRedirect/></ProtectedRoute>} />

          {/* Rutas protegidas */}
          {allRoutes.map((r) => (
            <Route
              key={r.path}
              path={r.path}
              element={<ProtectedRoute allowedRoles={r.roles}>{r.element}</ProtectedRoute>}
            />
          ))}

          <Route path="*" element={<div className="p-6">No encontrado</div>} />
        </Routes>
      </main>
    </div>
  );
}